import moment from 'moment';


export default function AuditedByDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  bcpDataService
) {
  const vm = this;

  vm.auditDateMinDate = moment().add(
    -180,
    'days'
  );
  vm.auditCurrentDate = moment().add(
    0,
    'days'
  );
  vm.auditDateMaxDate = vm.auditCurrentDate;
  vm.confirmSubmit = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveAuditedBy = _handleSaveAuditedBy;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.auditDate = moment(
      vm.auditCurrentDate
    ).format('MM/DD/YYYY');
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.auditedByDialog);
  }

  function _handleSaveAuditedBy() {
    const dfdSave = $q.defer();

    if ($scope.bcpAuditedByForm.$valid) {
      bcpDataService.auditedBy(
        vm.assessmentId,
        vm.auditedBy,
        vm.auditDate
      ).then((response) => {
        if (!response.data.result) {
          alerts.error('Error occurred while saving Process / Document Audited By.');
        } else {
          alerts.success(
            'The BCP assessment Process/ Document Audited by is saved successfully.'
          );
          $rootScope.$broadcast('refreshBCPAssessments');
          ssDialogService.hide(ssDialogService.dialogs.bcp.auditedByDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }
}

AuditedByDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'bcpDataService'
];
